var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturedimg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 60C120 109.264 109.264 120 60 120C10.7357 120 0 109.264 0 60C0 10.7357 10.7357 0 60 0C109.264 0 120 10.7357 120 60Z",
    fill: "#F4F4F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.96 36.9306V59.9107C33.96 67.6821 37.6808 74.9867 43.9664 79.5596L58.2588 89.96L72.5513 79.5596C78.8369 74.9867 82.5577 67.6821 82.5577 59.9107V36.9306L58.2588 29.96L33.96 36.9306Z",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9482 59.6538L55.026 66.7315L68.5691 53.1884",
    stroke: "#0A090A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturedimg1);
export default __webpack_public_path__ + "static/media/featuredimg1.e8967ecff3d92f050e49e6125830e4bc.svg";
export { ForwardRef as ReactComponent };